/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Zalify has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
  
  var review_elem = document.querySelector('.custom-review__slider');
  var review_options = {
    "cellAlign": 'left',
    "prevNextButtons": false,
    "freeScroll": false,
    "wrapAround": true
  }

  // Change when larger screen is loaded
  if ( matchMedia('screen and (max-width: 1000px)').matches ) {
    review_options.cellAlign = 'center';
  }
  if(review_elem) {
    var review_flkty = new Flickity( review_elem, review_options);
    var btnPrev = document.querySelector('.custom-review__prev');
    var btnNext = document.querySelector('.custom-review__next');
    if(btnPrev && btnNext) {
      document.querySelector('.custom-review__prev').addEventListener('click', function() {
        review_flkty.previous();
      });
      document.querySelector('.custom-review__next').addEventListener('click', function() {
        review_flkty.next()
      });
    };
  }
  
  var ugc_elem = document.querySelector('.ugc-slider');
  if(ugc_elem) {
    var ugc_options = {
      "cellAlign": 'left',
      "prevNextButtons": true,
      "freeScroll": true,
      "wrapAround": true
    }
  
    // Change when larger screen is loaded
    if ( matchMedia('screen and (max-width: 1000px)').matches ) {
      ugc_options.cellAlign = 'center';
    }
    var flkty = new Flickity( ugc_elem, ugc_options);
  };

  // Press
  var press_title_elem = document.querySelector('.press-title-list');
  if(press_title_elem) {
    var press_title_options = {
      "cellAlign": 'left',
      "prevNextButtons": false,
      "freeScroll": false,
      "wrapAround": true,
      "pageDots": false
    }
    var press_title_flkty = new Flickity( press_title_elem, press_title_options);
  };

  var press_elem = document.querySelector('.press-logos');
  if(press_elem) {
    var press_options = {
      "asNavFor": '.press-title-list',
      "cellAlign": 'center',
      "prevNextButtons": false,
      "freeScroll": true,
      "wrapAround": true,
      "pageDots": false
    }
  
    // Change when larger screen is loaded
    if ( matchMedia('screen and (max-width: 1000px)').matches ) {
      press_options.cellAlign = 'center';
    }
    var press_flkty = new Flickity( press_elem, press_options);
  };

  var frequently_bought_elem = document.querySelector('.frequently-bought__list');
    if(frequently_bought_elem) {
      var frequently_bought_options = {
        "cellAlign": 'left',
        "prevNextButtons": false,
        "freeScroll": false,
        "wrapAround": true,
        "pageDots": true
      }
      var frequently_bought_flkty = new Flickity( frequently_bought_elem, frequently_bought_options);
      var btnPrev = document.querySelector('.frequently-bought__btn-prev');
      var btnNext = document.querySelector('.frequently-bought__btn-next');
      if(btnPrev && btnNext) {
        btnPrev.addEventListener('click', function() {
          frequently_bought_flkty.previous();
        });
        btnNext.addEventListener('click', function() {
          frequently_bought_flkty.next()
        });
      };
    }

// video section
(function() {
    // window.addEventListener("DOMContentLoaded", event=>{
    //     document.querySelectorAll(".video-wrapper--native").forEach(widget=>{
    //         const bgVideo = widget.querySelector("video");
    //         bgVideo.insertAdjacentHTML("afterEnd", `
    //       <div class="vw--mute-and-unmute">
    //         <button type="button" aria-label="MuteUnmute" id="videoSound">
    //           <svg class="unmute" width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1807_71)"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.7497 5.98593C16.7825 4.40065 15.0228 3.44239 13.7146 4.35062L13.7146 4.35061L13.7117 4.35267L7.84145 8.49047H5.75004C4.65534 8.49047 3.7501 9.40119 3.7501 10.4955V13.5055C3.7501 14.5998 4.65534 15.5105 5.75004 15.5105H7.83849L13.5723 19.6451L13.5723 19.6452L13.5796 19.6503C14.876 20.5504 16.7146 19.6124 16.7495 18.0316L16.7497 18.0316V18.0205V5.98593ZM14.2862 5.17114C14.9173 4.73448 15.7683 5.18975 15.7498 5.96854L15.7497 5.96854V5.98041V18.0144C15.7284 18.7964 14.7912 19.2702 14.1532 18.8311L8.2924 14.605C8.20725 14.5436 8.10494 14.5105 7.99996 14.5105H5.75004C5.21081 14.5105 4.7501 14.0507 4.7501 13.5055V10.4955C4.7501 9.9503 5.2108 9.49047 5.75004 9.49047H7.99996C8.1031 9.49047 8.20372 9.45857 8.28803 9.39914L14.2849 5.17207L14.2862 5.17114ZM22.0158 5.55815C22.2599 5.42887 22.5625 5.52188 22.6917 5.76589C23.6899 7.64995 24.2266 9.80043 24.2499 11.9947L24.25 12.0053L24.2499 12.0053C24.2266 14.1995 23.6899 16.35 22.6917 18.234C22.5625 18.4781 22.2599 18.5711 22.0158 18.4418C21.7718 18.3125 21.6788 18.0099 21.8081 17.7659C22.7282 16.0291 23.2274 14.0382 23.2499 12C23.2274 9.96176 22.7282 7.97083 21.8081 6.23404C21.6788 5.99003 21.7718 5.68742 22.0158 5.55815ZM19.6754 8.73735C19.5304 8.50237 19.2223 8.42945 18.9873 8.57449C18.7523 8.71953 18.6794 9.0276 18.8244 9.26259C19.2861 10.0105 19.5321 10.9807 19.4965 11.9822C19.4961 11.9941 19.4961 12.0059 19.4965 12.0177C19.5321 13.0193 19.2861 13.9895 18.8244 14.7374C18.6794 14.9723 18.7523 15.2804 18.9873 15.4254C19.2223 15.5705 19.5304 15.4976 19.6754 15.2626C20.2486 14.334 20.5348 13.1717 20.4965 12C20.5348 10.8283 20.2486 9.66595 19.6754 8.73735Z" fill="white"/></g><defs><filter id="filter0_d_1807_71" x="-1" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1807_71"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1807_71" result="shape"/></filter></defs></svg>
    //         </button>
    //       </div>

    //       <div class="vw--unmute">
    //         <svg class="unmute" width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1807_71)"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.7497 5.98593C16.7825 4.40065 15.0228 3.44239 13.7146 4.35062L13.7146 4.35061L13.7117 4.35267L7.84145 8.49047H5.75004C4.65534 8.49047 3.7501 9.40119 3.7501 10.4955V13.5055C3.7501 14.5998 4.65534 15.5105 5.75004 15.5105H7.83849L13.5723 19.6451L13.5723 19.6452L13.5796 19.6503C14.876 20.5504 16.7146 19.6124 16.7495 18.0316L16.7497 18.0316V18.0205V5.98593ZM14.2862 5.17114C14.9173 4.73448 15.7683 5.18975 15.7498 5.96854L15.7497 5.96854V5.98041V18.0144C15.7284 18.7964 14.7912 19.2702 14.1532 18.8311L8.2924 14.605C8.20725 14.5436 8.10494 14.5105 7.99996 14.5105H5.75004C5.21081 14.5105 4.7501 14.0507 4.7501 13.5055V10.4955C4.7501 9.9503 5.2108 9.49047 5.75004 9.49047H7.99996C8.1031 9.49047 8.20372 9.45857 8.28803 9.39914L14.2849 5.17207L14.2862 5.17114ZM22.0158 5.55815C22.2599 5.42887 22.5625 5.52188 22.6917 5.76589C23.6899 7.64995 24.2266 9.80043 24.2499 11.9947L24.25 12.0053L24.2499 12.0053C24.2266 14.1995 23.6899 16.35 22.6917 18.234C22.5625 18.4781 22.2599 18.5711 22.0158 18.4418C21.7718 18.3125 21.6788 18.0099 21.8081 17.7659C22.7282 16.0291 23.2274 14.0382 23.2499 12C23.2274 9.96176 22.7282 7.97083 21.8081 6.23404C21.6788 5.99003 21.7718 5.68742 22.0158 5.55815ZM19.6754 8.73735C19.5304 8.50237 19.2223 8.42945 18.9873 8.57449C18.7523 8.71953 18.6794 9.0276 18.8244 9.26259C19.2861 10.0105 19.5321 10.9807 19.4965 11.9822C19.4961 11.9941 19.4961 12.0059 19.4965 12.0177C19.5321 13.0193 19.2861 13.9895 18.8244 14.7374C18.6794 14.9723 18.7523 15.2804 18.9873 15.4254C19.2223 15.5705 19.5304 15.4976 19.6754 15.2626C20.2486 14.334 20.5348 13.1717 20.4965 12C20.5348 10.8283 20.2486 9.66595 19.6754 8.73735Z" fill="white"/></g><defs><filter id="filter0_d_1807_71" x="-1" y="-2" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1807_71"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1807_71" result="shape"/></filter></defs></svg>
    //       </div>`);
    //         bgVideo.style.cursor = "pointer",
    //         bgVideo.classList.add("video--loading"),
    //         bgVideo.classList.add("video--muted");
    //         bgVideo.addEventListener("click", muteUnmute);
    //         widget.querySelector(".vw--mute-and-unmute").addEventListener("click", muteUnmute);
    //         bgVideo.paused && bgVideo.classList.add("video--paused");
    //         bgVideo.classList.remove("video--loading");
    //         function muteUnmute() {
    //             const unmuteBtn = document.getElementById("videoSound").querySelector(".unmute");
    //             if(bgVideo.muted) {
    //               bgVideo.classList.remove("video--muted");
    //               bgVideo.muted = !1;
    //               bgVideo.currentTime = 0;
    //               bgVideo.play();
    //               bgVideo.classList.remove("video--paused");
    //               unmuteBtn.style.display = "block";
    //             } else {
    //               bgVideo.classList.add("video--muted");
    //               bgVideo.muted = !0;
    //               unmuteBtn.style.display = "none";
    //             }
    //         }
    //     })
    // })
})(); 

document.querySelectorAll(".show-more-color ").forEach(function(el) {
    el.addEventListener("click", (event) => {
        event.stopPropagation();
        const parentElement = el.parentElement;
        parentElement.querySelectorAll(".color-swatch").forEach(function(colorEl) {
            colorEl.classList.remove("color-swatch--hidden");
        });
        el.style.display = "none";
    })
}) 